import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from "@angular/core";
import { Subject } from "rxjs";
import { LeftNavService } from "@core/service/left-nav.service";
import { takeUntil } from "rxjs/operators";

import { IconList } from "@schema/ui/icons";
import { faHome, faTags, faFile, faTasks, faCog } from "@fortawesome/free-solid-svg-icons";
import { faAnalytics, faShieldAlt, faChevronDoubleLeft } from "@fortawesome/pro-regular-svg-icons";

@Component({
  selector: "app-content-layout",
  templateUrl: "./content-layout.component.html",
  styleUrls: ["./content-layout.component.scss"],
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentLayoutComponent implements OnInit, OnDestroy {

  /**
   * Site Title
   */
  public title = "Innovian";

  /**
   * If the sidebar is collapsed
   */
  get sidebarCollapsed(): boolean {
    return this._collapsed;
  }
  protected _collapsed = false;


  public icons: IconList = {
    dashboard: faHome,
    reports: faAnalytics,
    tags: faTags,
    pages: faFile,
    rules: faTasks,
    pii: faShieldAlt,
    settings: faCog,
    collapse: faChevronDoubleLeft,
  };

  /**
   * Component destroyed subscription
   */
  protected _compDestroyed = new Subject<boolean>();

  constructor(
    protected _leftNavService: LeftNavService,
  ) { }

  ngOnInit(): void {

    this._leftNavService.collapsed$.pipe(
      takeUntil(this._compDestroyed),
    ).subscribe((collapsed: boolean) => {
      this._collapsed = collapsed;
    });
  }

  ngOnDestroy(): void {
    this._compDestroyed.next();
    this._compDestroyed.complete();
  }

  toggleSidebar(): void {
    this._leftNavService.toggleCollapse();
  }

}
